import { connect } from 'react-redux'
import { loadSnacks } from './reducer'

const mapStateToProps = (state) => {
    return {
        snacksListOffer: state?.pages?.yourOrder?.snacksList?.snacksListOffer,
        snacksInBasket: state?.components?.basket?.data?.items_vouchers,
    }
}

const mapDispatchToProps = { loadSnacks }

const hocAddSnackCoupon = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocAddSnackCoupon
